export default __webpack_public_path__ + "static/media/background.408cf3c1.png";